jQuery.fn.isInViewport = function() {
    var elementTop = jQuery(this).offset().top;
    var elementBottom = elementTop + jQuery(this).outerHeight();

    var viewportTop = jQuery(window).scrollTop();
    var viewportBottom = viewportTop + jQuery(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

setInterval(function() {
    jQuery('video').each(function(){
        if (jQuery(this).isInViewport()) {
            jQuery(this)[0].play();
        } else {
            jQuery(this)[0].pause();
        }
    });
}, 1000);